(() => {
  if (window.CodexProductOptions) return;
  window.CodexProductOptions = true;

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLocaleLowerCase();

  const patchImages = {
    'premier league': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/09da7b138f4297f31fb6099dce28b69dd36c2a40a7e54b29c481166e589c6d42.webp?v=1772653428',
    'bundesliga': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/images_8.jpg?v=1772653428',
    'serie a': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/images_9.jpg?v=1772653428',
    'liga mx': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/images_10.jpg?v=1772653428',
    'la liga': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/30072520_blbmtpn7ea1qjn6h.webp?v=1772653428',
    'laliga': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/30072520_blbmtpn7ea1qjn6h.webp?v=1772653428',
    'ligue 1 mcdonald': 'https://cdn.shopify.com/s/files/1/0941/8611/1259/files/patch-ligue-1-mcdonalds-winners-psg.png?v=1784741291',
    'ligue 1': 'https://cdn.shopify.com/s/files/1/0941/8611/1259/files/patch-ligue-1-psg.jpg?v=1784737977',
    'eredivisie': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/610.webp?v=1772653428',
    'liga portugal': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/610_1.webp?v=1772653428',
    'brasileirao': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/Patch-Brasileirao2025-1_00f8702d-645a-4493-88cb-a65b8f00e558.webp?v=1772653428',
    'saudi pro': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/2022-24-rsl-saudi-arabia-league-patch-repr1709662524.jpg?v=1772653428',
    'super lig': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/images_11.jpg?v=1772653428',
    'superliga argentina': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/images_13.jpg?v=1772653428',
    'liga dimayor': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/images_12.jpg?v=1772653428',
    'champions league': 'https://cdn.shopify.com/s/files/1/0941/8611/1259/files/patch-uefa-champions-league-psg.jpg?v=1784737966',
    'intercontinental champions': 'https://cdn.shopify.com/s/files/1/0941/8611/1259/files/patch-intercontinental-champions-2025-psg.png?v=1784737959',
    'ucl title': 'https://cdn.shopify.com/s/files/1/0941/8611/1259/files/patch-ucl-title-psg.jpg?v=1784737983',
    'europa league': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/fe21600d3beb7d54246308df817e37264f4105bf8fe1ecd224d5668200cf47f5.webp?v=1772653428',
    'world cup': 'https://cdn.shopify.com/s/files/1/0974/7290/5511/files/are-these-the-official-2026-world-cup-patches-v0-p1837uw6pl6g1.webp?v=1772653428',
    'world champions': 'https://cdn.shopify.com/s/files/1/0941/8611/1259/files/patch-fifa-world-champions-2026.png?v=1784736393'
  };

  const expectedPatchesByClub = {
    BAR: ['Add Champions League Patch'],
    REA: ['Add Champions League Patch'],
    ARS: ['Add Champions League Patch'],
    LIV: ['Add Champions League Patch'],
    CIT: ['Add Champions League Patch'],
    BAY: ['Add Champions League Patch'],
    ATL: ['Add Champions League Patch'],
    INT: ['Add Champions League Patch'],
    IM: ['Add Champions League Patch'],
    ASR: ['Add Champions League Patch'],
    ESP: ['Patch FIFA World Champions 2026']
  };

  const virtualPatchSelections = new Map();
  const personalizationValues = new Map();

  const isNegative = (text) => {
    const value = normalize(text);
    return value.startsWith('non ') || value.startsWith('nao ') || value.startsWith('no ') || value.startsWith('do not ');
  };

  const patchImageFor = (label) => {
    const text = normalize(label);
    const match = Object.keys(patchImages).find((name) => text.includes(name));
    return match ? patchImages[match] : '';
  };

  const expectedPatchesFor = (section) => {
    const title = section.querySelector('.product-info__title')?.textContent || '';
    const normalizedTitle = title.toLocaleUpperCase();
    const club = Object.keys(expectedPatchesByClub).find((code) => {
      return new RegExp(`(^|[^A-Z])${code}([^A-Z]|$)`).test(normalizedTitle);
    });
    return club ? expectedPatchesByClub[club] : [];
  };

  const initRoot = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const section = root.closest('[id^="shopify-section-"]');
    const variantPicker = section?.querySelector('variant-picker[form-id]');
    const formId = variantPicker?.getAttribute('form-id');
    const productForm = formId ? document.getElementById(formId) : null;
    if (!section || !variantPicker || !productForm) return;

    const fieldsets = Array.from(variantPicker.querySelectorAll('.variant-picker__option'));
    const optionName = (fieldset) => normalize(fieldset.querySelector('legend')?.textContent);
    const personalizationFieldset = fieldsets.find((fieldset) => {
      const name = optionName(fieldset);
      return name.includes('personaliz') || name.includes('customiz') || name.includes('nome + numero');
    });
    const patchFieldset = fieldsets.find((fieldset) => optionName(fieldset).includes('patch'));

    const personalizationTrigger = root.querySelector('[data-codex-personalize-trigger]');
    const personalizationPanel = root.querySelector('[data-codex-personalization-panel]');
    const patchTrigger = root.querySelector('[data-codex-patch-trigger]');
    const patchPanel = root.querySelector('[data-codex-patch-panel]');
    const patchChoices = root.querySelector('[data-codex-patch-choices]');
    if (!personalizationTrigger || !personalizationPanel || !patchTrigger || !patchPanel || !patchChoices) return;

    root.dataset.initialized = 'true';
    const nativeLabels = (fieldset) => Array.from(fieldset?.querySelectorAll('label') || []);
    const nativeInput = (label) => {
      if (!label) return null;
      const nestedInput = label.querySelector('input[type="radio"]');
      if (nestedInput) return nestedInput;
      return label.htmlFor ? document.getElementById(label.htmlFor) : null;
    };
    const selectNative = (label) => {
      const input = nativeInput(label);
      if (input && !input.checked && !input.disabled) input.click();
    };
    const selectedLabel = (fieldset) => nativeLabels(fieldset).find((label) => nativeInput(label)?.checked);

    if (personalizationFieldset) {
      personalizationFieldset.classList.add('codex-native-option-hidden');
      const fields = Array.from(personalizationPanel.querySelectorAll('input'));
      const savedValues = personalizationValues.get(formId);
      if (savedValues) {
        fields[0].value = savedValues.name || '';
        fields[1].value = savedValues.number || '';
      }
      const personalizedLabel = nativeLabels(personalizationFieldset).find((label) => !isNegative(label.textContent));
      const notPersonalizedLabel = nativeLabels(personalizationFieldset).find((label) => isNegative(label.textContent));

      const setPersonalizationOpen = (open, updateVariant = true) => {
        if (updateVariant) selectNative(open ? personalizedLabel : notPersonalizedLabel);
        personalizationPanel.hidden = !open;
        personalizationTrigger.setAttribute('aria-expanded', String(open));
        fields.forEach((field) => {
          field.disabled = !open;
          field.required = open;
          if (!open) field.value = '';
        });
        if (!open) personalizationValues.delete(formId);
        if (open) fields[0]?.focus({ preventScroll: true });
      };
      const syncPersonalization = () => {
        const selected = selectedLabel(personalizationFieldset);
        setPersonalizationOpen(Boolean(selected && !isNegative(selected.textContent)), false);
      };

      personalizationTrigger.addEventListener('click', () => {
        setPersonalizationOpen(personalizationTrigger.getAttribute('aria-expanded') !== 'true');
      });
      fields[0]?.addEventListener('input', (event) => {
        event.currentTarget.value = event.currentTarget.value.toLocaleUpperCase();
        personalizationValues.set(formId, {
          name: event.currentTarget.value,
          number: fields[1]?.value || ''
        });
      });
      fields[1]?.addEventListener('input', (event) => {
        event.currentTarget.value = event.currentTarget.value.replace(/\D/g, '').slice(0, 3);
        personalizationValues.set(formId, {
          name: fields[0]?.value || '',
          number: event.currentTarget.value
        });
      });
      variantPicker.addEventListener('change', syncPersonalization);
      syncPersonalization();
    } else {
      personalizationTrigger.hidden = true;
      personalizationPanel.hidden = true;
    }

    const expectedPatches = expectedPatchesFor(section);
    if (patchFieldset || expectedPatches.length) {
      patchFieldset?.classList.add('codex-native-option-hidden');
      const notAddedLabel = nativeLabels(patchFieldset).find((label) => isNegative(label.textContent));
      const patchProperty = document.createElement('input');
      patchProperty.type = 'hidden';
      patchProperty.name = 'properties[Patch]';
      patchProperty.setAttribute('form', formId);
      patchProperty.value = virtualPatchSelections.get(formId) || '';
      root.appendChild(patchProperty);

      const syncPatchChoices = () => {
        const selected = selectedLabel(patchFieldset);
        const virtualPatch = virtualPatchSelections.get(formId) || '';
        patchProperty.value = virtualPatch;
        Array.from(patchChoices.children).forEach((button) => {
          const pressed = button.dataset.virtualPatch
            ? button.dataset.virtualPatch === virtualPatch
            : !virtualPatch && button.dataset.nativeId === nativeInput(selected)?.id;
          button.setAttribute('aria-pressed', String(pressed));
        });
      };

      const createPatchChoice = (labelText, label = null) => {
        const input = nativeInput(label);
        const imageUrl = patchImageFor(labelText);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'codex-product-options__choice';
        if (input) button.dataset.nativeId = input.id;
        if (!label) button.dataset.virtualPatch = labelText;
        button.setAttribute('aria-label', `${labelText}, free`);

        const image = document.createElement('span');
        image.className = 'codex-product-options__choice-image';
        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          image.appendChild(img);
        } else {
          image.classList.add('codex-product-options__choice-image--empty');
          image.textContent = isNegative(labelText) ? '—' : '🛡️';
        }

        const name = document.createElement('span');
        name.className = 'codex-product-options__choice-name';
        name.textContent = labelText;
        const free = document.createElement('span');
        free.className = 'codex-product-options__free';
        free.textContent = 'FREE';
        const radio = document.createElement('span');
        radio.className = 'codex-product-options__radio';
        radio.setAttribute('aria-hidden', 'true');
        button.append(image, name, free, radio);
        button.addEventListener('click', () => {
          if (label) {
            virtualPatchSelections.delete(formId);
            patchProperty.value = '';
            selectNative(label);
          } else {
            virtualPatchSelections.set(formId, labelText);
            patchProperty.value = labelText;
            selectNative(notAddedLabel);
          }
          syncPatchChoices();
        });
        patchChoices.appendChild(button);
      };

      const nativePatchNames = nativeLabels(patchFieldset).map((label) => normalize(label.textContent));
      nativeLabels(patchFieldset).forEach((label) => {
        if (nativeInput(label)) createPatchChoice(label.textContent.trim(), label);
      });
      expectedPatches.forEach((patchName) => {
        const alreadyExists = nativePatchNames.some((name) => name.includes(normalize(patchName).replace('add ', '').replace(' patch', '')));
        if (!alreadyExists) createPatchChoice(patchName);
      });

      patchTrigger.addEventListener('click', () => {
        const open = patchTrigger.getAttribute('aria-expanded') !== 'true';
        patchPanel.hidden = !open;
        patchTrigger.setAttribute('aria-expanded', String(open));
        if (open) patchChoices.querySelector('button')?.focus({ preventScroll: true });
      });
      variantPicker.addEventListener('change', syncPatchChoices);
      syncPatchChoices();
    } else {
      patchTrigger.hidden = true;
      patchPanel.hidden = true;
    }
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-codex-product-options]')) initRoot(scope);
    scope.querySelectorAll?.('[data-codex-product-options]').forEach(initRoot);
  };

  const start = () => {
    initAll();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) initAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
